'use client';
import { useEffect } from 'react';
import { useRouter } from '@whelk/hooks/src/useRouter';

export default function NotFound() {
  const nav = useRouter();
  useEffect(() => {
    nav.push('/'); // Redirect to home page
  }, []);

  return null;
}
